import {TripCollection} from "../Trip";
import dayChildBucuresti from "./dayChildBucuresti";
import dayChildAlba from "./dayChildAlba";
import dayChildSibiu from "./dayChildSibiu";
import dayChildSighi from "./dayChildSighi";
import dayChildCoh from "./dayChildCoh";
import dayChildFagaras from "./dayChildFagaras";
import dayChildZimbri from "./dayChildZimbri";
import dayChildTarguSecuiesc from "./dayChildTarguSecuiesc";
import dayChildValeaPh from "./dayChildValeaPh";
import dayChildTargoviste from "./dayChildTargoviste";
import dayChildCurtea from "./dayChildCurtea";
import dayChildSaline from "./dayChildSaline";
import dayChildAproape from "./dayChildAproape";
import dayChildCraciun from "./dayChildCraciun";
import dayChildAltele from "./dayChildAltele";

const childDayTrips: Array<TripCollection> = [
    dayChildBucuresti,
    dayChildAlba,
    dayChildSibiu,
    dayChildSighi,
    dayChildCoh,
    dayChildFagaras,
    dayChildZimbri,
    dayChildTarguSecuiesc,
    dayChildValeaPh,
    dayChildTargoviste,
    dayChildCurtea,
    dayChildSaline,
    dayChildAproape,
    dayChildCraciun,
    dayChildAltele
]

export default childDayTrips;